module.exports = __webpack_public_path__ + "static/media/choose_class_1_decoration.8d63f89c.svg";